const initialState = {
  plans: [],
  error: null,
  isLoding: false
};

const SubscripationPlanApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_PLANS_SUCCESS":
      return {
        ...state,
        plans: action.payload,
        error: null
      };
    case "GET_PLANS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
      case "ADD_REQUEST_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_REQUEST_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_CONTACT_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_CONTACT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    default:
      return state;
  }
};

export default SubscripationPlanApiReducer;
